<template>
    <div class="variants">
        <div class="headline" :style="{'--textColor':featureFlags.text_color}">
            <div class="form-group" v-for="variant in currentVariants" :key="variant.key">
                <hr v-if="variant.separator">

                <div v-if="variant.selection === configContractType.single && variant.displayType === 'dropdown'  && featureFlags.insurance_type !== 'dropdown'">
                    <label :for="variant.key">
                        <span v-if="variant.text != null" v-html="variant.text" class="headline"></span>
                        <span v-else class="headline">{{ variant.value }}</span>
                    </label>

                    <a class="hoverinfo" id="deductible-question-sign" tabindex="0" role="button" data-toggle="popover"
                       data-trigger="focus" v-if="variant.hoverText" :data-content="variant.hoverText">
                        <i class="glyphicon glyphicon-question-sign"></i>
                    </a>
                <div class="dropdown-list">
                    <select class="form-control" :id="variant.key" :disabled="variant.options.length === 0"
                            v-model="selectedVariantOptions[variant.key]">
                        <option v-for="(option) in variant.options" :id="option.key" :key="option.key"
                                :value="option.key">
                            <span v-if="option.text != null" v-html="option.text"></span>
                            <span v-else>{{ option.value }}</span>
                        </option>
                    </select>
                </div>
                </div>

                <div v-if="variant.selection === configContractType.single && variant.displayType === 'checkbox'">
                    <div v-if="isPartnerTool || !variant.hideVariant">
                        <div v-if="product.checkboxHeadline" v-html="product.checkboxHeadline"></div>
                        <div class="checkbox">
                            <label>
                                <input type="checkbox" :id=variant.value v-model="selectedVariantOptions[variant.key]"
                                       :true-value="variant.options[1].key" :false-value="variant.options[0].key">
                                <span v-if="variant.options[1].longText != null"
                                      v-html="variant.options[1].longText"></span>
                                <span v-else-if="variant.options[1].text != null"
                                      v-html="variant.options[1].text"></span>
                                <span v-else>{{ variant.options[1].value }}</span>
                            </label>

                            <a class="hoverinfo" :id="variant.value + '-question-sign'" tabindex="0" role="button"
                               data-toggle="popover"
                               data-trigger="focus" v-if="variant.hoverText" :data-content="variant.hoverText">
                                <i class="glyphicon glyphicon-question-sign"></i>
                            </a>

                            <a class="hoverinfo" tabindex="0" role="button" data-toggle="popover"
                               data-trigger="focus" v-if="variant.options[1].hoverText"
                               :data-content="variant.options[1].hoverText">
                                <i class="glyphicon glyphicon-question-sign"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div v-if="featureFlags.insurance_type == 'dropdown'">
                    <div v-if="variant.text != null" v-html="variant.text" class="headline"></div>
                    <div class="dropdown-list">
                        <select class="form-control" :id="variant.key" :disabled="variant.options.length === 0"
                                v-model="selectedVariantOptions[variant.key]">
                             <option v-for="option in variant.options" :key="option.key" :value="option.key">
                                {{ option.text }}
                             </option>
                        </select>
                  </div>
                </div>

                <div v-else>
                    <div
                        v-if="variant.selection === configContractType.single && (variant.displayType === 'radio' || variant.displayType === 'radio-inline')">
                        <div>
                            <span v-if="variant.text != null" v-html="variant.text" class="headline"></span>
                            <span v-else class="headline">{{ variant.value }}</span>
                            <a class="hoverinfo" :id="variant.key + '-question-sign'" tabindex="0" role="button"
                               data-toggle="popover"
                               data-trigger="focus" v-if="variant.hoverText" :data-content="variant.hoverText">
                                <i class="glyphicon glyphicon-question-sign"></i>
                            </a>
                        </div>

                        <div v-for="(option, index) in variant.options" :class="variant.displayType"
                             :key="option.key">
                            <div v-if="isPartnerTool || !option.hideOption">
                                <label>
                                    <input type="radio" :id=option.key v-model="selectedVariantOptions[variant.key]"
                                           :value="option.key" class="radio-button-color">
                                    <span class="long" v-if="isEmptyHtml(option.longText)"
                                          v-html="option.longText"></span>
                                    <span class="text" v-else-if="option.text != null" v-html="option.text"></span>
                                    <span v-else class="option.value">{{ option.value }}</span>
                                </label>

                                <a class="hoverinfo" :id="option.key + '-question-sign'" tabindex="0" role="button"
                                   :data-toggle="'popover'+index"
                                   data-trigger="focus" v-if="option.hoverText" :data-content="option.hoverText">
                                    <i class="glyphicon glyphicon-question-sign"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['currentVariants', 'configContractType', 'selectedVariantOptions', 'isPartnerTool', 'featureFlags', 'product'],
    methods: {
        isEmptyHtml: function (input) {
            let regex = /<[a-zA-Z]+>[a-zA-Z]+<\/[a-zA-Z]+>/i
            return regex.test(input)
        }
    },
    name: "ProductVariants"
}
</script>

<style scoped>
.form-group {
    margin-bottom: 0;
}

.variants {
    margin-top: 15px;
}
</style>
